import React from "react";
import QRCode from "qrcode";
import jsPDF from "jspdf";
import { toast } from "react-toastify";
import { slugify } from "../utils/profailUtils";

const loadHtmlImage = (src) =>
    new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error("Image decode fail"));
        img.src = src;
    });

const loadImageAsDataURL = async (url) => {
    if (!url) return null;

    try {
        // ✅ kalau data/blob, terus decode
        if (/^(data:|blob:)/i.test(url)) {
            const img = await loadHtmlImage(url);
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth || img.width;
            canvas.height = img.naturalHeight || img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            return canvas.toDataURL("image/png");
        }

        // ✅ cara paling stabil: fetch -> blob -> bitmap
        const busted = (() => {
            try {
                const u = new URL(url);
                u.searchParams.set("_cb", String(Date.now()));
                return u.toString();
            } catch {
                return url;
            }
        })();

        const res = await fetch(busted, { mode: "cors", cache: "no-store" });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const blob = await res.blob();

        let drawable = null;
        let revokeUrl = null;

        try {
            drawable = await createImageBitmap(blob);
        } catch {
            // fallback: blobURL -> Image
            revokeUrl = URL.createObjectURL(blob);
            drawable = await loadHtmlImage(revokeUrl);
        }

        const w = drawable.width || drawable.naturalWidth;
        const h = drawable.height || drawable.naturalHeight;

        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(drawable, 0, 0);

        if (revokeUrl) URL.revokeObjectURL(revokeUrl);
        return canvas.toDataURL("image/png");
    } catch (e) {
        console.warn("[QR PDF] loadImageAsDataURL FAIL:", url, e?.message || e);
        return null; // ✅ jangan crash PDF
    }
};

export default function WebsiteCard({ editMode, draft, setDraft }) {
    const setField = (field, value) => setDraft({ ...draft, [field]: value });

    const slug = slugify(draft?.slug || "");
    const url = slug ? `https://etikaf.com/${slug}` : "";

    const generateQrPdf = async () => {
        if (!slug) return toast.error("Sila isi slug dulu");

        try {
            const qrDataUrl = await QRCode.toDataURL(url, {
                width: 800,
                margin: 2,
                errorCorrectionLevel: "H",
            });

            const logoUrl = draft?.logo || `${window.location.origin}/assets/etikaf-logo.png`;
            const logoImg = await loadImageAsDataURL(logoUrl);


            const pdf = new jsPDF("p", "mm", "a4");
            pdf.setFontSize(18);
            pdf.text("Scan untuk halaman masjid", 105, 22, { align: "center" });

            pdf.setFontSize(11);
            pdf.text(url, 105, 32, { align: "center" });

            const qrSize = 100;
            const qrX = 55;
            const qrY = 45;
            pdf.addImage(qrDataUrl, "PNG", qrX, qrY, qrSize, qrSize);

            const logoSize = 20;
            const logoX = qrX + qrSize / 2 - logoSize / 2;
            const logoY = qrY + qrSize / 2 - logoSize / 2;

            if (logoImg) {
                pdf.setFillColor(255, 255, 255);
                pdf.rect(logoX - 5, logoY - 5, logoSize + 10, logoSize + 10, "F");
                pdf.addImage(logoImg, "PNG", logoX, logoY, logoSize, logoSize);
            } else {
                // optional: kalau logo fail, QR masih ok
                console.warn("[QR PDF] Logo tak dapat load, generate tanpa logo");
            }


            pdf.setFontSize(10);
            pdf.text("etikaf.com", 105, 155, { align: "center" });

            pdf.save(`QR-${slug}.pdf`);
        } catch (err) {
            console.error(err);
            toast.error("Gagal jana QR PDF");
        }
    };

    return (
        <div className="pv2-block">
            {/* Button atas sekali */}
            <div style={{ marginBottom: 10 }}>
                <button
                    type="button"
                    className="button"
                    style={{ width: "100%" }}
                    onClick={generateQrPdf}
                    disabled={!slug}
                >
                    Jana Website QR Code
                </button>
            </div>

            {/* Field slug */}
            <div className="field-container">
                <label className="field-label">Slug</label>

                {!editMode ? (
                    <h4 className="field-value">{slug || "-"}</h4>
                ) : (
                    <input
                        value={draft?.slug || ""}
                        onChange={(e) => setField("slug", slugify(e.target.value))}
                        className="field-input"
                        placeholder="masjidsaya"
                    />
                )}
            </div>

            {/* Preview link */}
            <div className="field-container">
                <label className="field-label">Preview</label>
                <div className="field-value" style={{ fontSize: 13, opacity: 0.8 }}>
                    {url ? url : "-"}
                </div>
            </div>
        </div>
    );
}
